/**
 * Le sous-barrel de l'espace TUTEUR — lu par les seuls ports tuteur (`ports/primary/…/tutor/`).
 *
 * Le modèle est celui de l'élève (`./student.ts`) : les écrans du tuteur ne passent pas par le barrel
 * public (`./index.ts`), que l'app entière lit ; l'espace tuteur n'y entre qu'allumé pour tous. Ce
 * que le parent et l'élève lisent aussi (`<ParentHeader>`, `<BottomTab>`, `<ProfileSwitcherSheet>`,
 * `<ScreenBackground>`…) reste dans le barrel public, et se lit de là.
 *
 * N'y entre que ce qu'un écran des ports lit : Metro évalue tout ce qu'un barrel réexporte. Chaque
 * domaine y ajoute ses pages quand il les câble.
 */

// ── La coquille ──
export type { ProfileSheetLink } from "./molecules/ProfileSwitcherSheet/ProfileSwitcherSheet"

// ── Accueil, « Ma journée » ──
export { TutorHomePage } from "./pages/TutorHomePage"
export type { TutorSessionNotice } from "./templates/TutorSessionNoticeDialog"

// ── Le compte ──
export { AccountAvatarMenu } from "./templates/AccountAvatarMenu"
export type { AccountAvatarMenuStep } from "./templates/AccountAvatarMenu"
export { TutorCoachingVideosPage } from "./pages/TutorCoachingVideosPage"
export { TutorInvoicesPage } from "./pages/TutorInvoicesPage"
export { TutorResourcesPage } from "./pages/TutorResourcesPage"
export { TutorSettingsGeneralPage } from "./pages/TutorSettingsGeneralPage"
export { TutorSettingsPage } from "./pages/TutorSettingsPage"
export { TutorTrainingPage } from "./pages/TutorTrainingPage"
export type { TutorTrainingPhase } from "./pages/TutorTrainingPage"
export { TutorCompleteProfilePage } from "./pages/TutorCompleteProfilePage"
// L'étape des créneaux de « Compléter mon profil » pose l'éditeur et la boîte de « Ma dispo ».
export { TutorWeekEditor } from "./organisms/TutorWeekEditor"
export { TutorAvailabilityDialog } from "./templates/TutorAvailabilityDialog"
// ── La dispo et les offres ──
export { TutorAvailabilityPage } from "./pages/TutorAvailabilityPage"
export { TutorReleaseSlotsPage } from "./pages/TutorReleaseSlotsPage"
export { TutorOffersPage } from "./pages/TutorOffersPage"
export { TutorOfferPage } from "./pages/TutorOfferPage"
// ── Les lives ──
export { TutorLivesListPage } from "./pages/TutorLivesListPage"
export { TutorLivesHistoryPage } from "./pages/TutorLivesHistoryPage"
export { TutorManageSessionFlow } from "./templates/TutorManageSessionFlow"
export { TutorPrepareLivePage } from "./pages/TutorPrepareLivePage"
export { TutorCloseOutPage } from "./pages/TutorCloseOutPage"
export { VoiceRecorderSheet } from "./templates/VoiceRecorderSheet"
export { TutorPrescriptionPage } from "./pages/TutorPrescriptionPage"
// La salle du live.
export { TutorLivePage } from "./pages/TutorLivePage"
export { TutorGenerateActivityFlow } from "./templates/TutorGenerateActivityFlow"
export { TutorRevisionProgramSheet } from "./templates/TutorRevisionProgramSheet"
// ── Mes élèves : la messagerie de la fiche ──
export { TutorMediaPreviewModal } from "./templates/TutorMediaPreviewModal"
// Mes élèves et la fiche d'un élève
export { TutorStudentsPage } from "./pages/TutorStudentsPage"
export { TutorStudentsTwoPane } from "./pages/TutorStudentsTwoPane"
export { TutorStudentProfilePage } from "./pages/TutorStudentProfilePage"
// La fiche d'une activité, ouverte de l'onglet Activités et des archives
export { TutorActivityDetailsModal } from "./templates/TutorActivityDetailsModal"
export { TWO_PANE_FROM } from "./templates/TwoPaneTemplate"

// ── La candidature ──
export { TutorApplicationPage } from "./pages/TutorApplicationPage"
export { TutorApplicationIntroPage } from "./pages/TutorApplicationIntroPage"
export { TutorApplicationQuestionPage } from "./pages/TutorApplicationQuestionPage"
export { TutorApplicationVideoQuestionPage } from "./pages/TutorApplicationVideoQuestionPage"
export { TutorApplicationRecordingPage } from "./pages/TutorApplicationRecordingPage"
export { TutorApplicationStepDonePage } from "./pages/TutorApplicationStepDonePage"

// ── Le précall (`pre-call`) ──
export { TutorPreCallPage } from "./pages/TutorPreCallPage"
